import type { LucideIcon } from 'lucide-react';
import { Inbox } from 'lucide-react';
import type { ReactNode } from 'react';

interface Props {
  title: string;
  description?: string;
  icon?: LucideIcon;
  action?: ReactNode;
}

/** Nothing here yet, said plainly — never decorated with the Checkover mark. */
export function EmptyState({ title, description, icon: Icon = Inbox, action }: Props) {
  return (
    <div className="flex flex-col items-center rounded-[14px] border border-hair bg-elev px-6 py-12 text-center">
      <div className="mb-3.5 flex h-12 w-12 items-center justify-center rounded-full bg-sunken text-ink3">
        <Icon size={22} strokeWidth={1.8} aria-hidden />
      </div>
      <div className="text-[17px] font-semibold text-ink">{title}</div>
      {description && <p className="mx-auto mt-1.5 max-w-sm text-[14.5px] leading-relaxed text-ink2">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
